import { put, call } from 'redux-saga/effects';
import * as API from '../../services/api';
import actionTypes from '../actionTypes';

export function* getPublishers() {
  try {
    const publishers = yield call(API.getPublishers);
    yield put({
      type: actionTypes.PUBLISHERS_GET_SUCCESS,
      publishers,
    });
  } catch (error) {
    yield put({
      type: actionTypes.PUBLISHERS_GET_ERROR,
      error,
    });
  }
}

export function* createPublisher({ publisher }) {
  try {
    const result = yield call(API.createPublisher, publisher);
    if (result.error) {
      yield put({
        type: actionTypes.PUBLISHER_CREATE_ERROR,
        error: result.error,
      });
    } else {
      yield put({
        type: actionTypes.PUBLISHER_CREATE_SUCCESS,
        publisher: result,
      });
    }
  } catch (error) {
    yield put({
      type: actionTypes.PUBLISHER_CREATE_ERROR,
      error,
    });
  }
}

export function* updatePublisher({ publisher }) {
  try {
    const result = yield call(API.updatePublisher, publisher);
    if (result.id) {
      yield put({
        type: actionTypes.PUBLISHER_UPDATE_SUCCESS,
        publisher: result,
      });
    } else {
      yield put({
        type: actionTypes.PUBLISHER_UPDATE_ERROR,
      });
    }
  } catch (error) {
    yield put({
      type: actionTypes.PUBLISHER_UPDATE_ERROR,
      error,
    });
  }
}

export function* deletePublisher({ publisher }) {
  try {
    yield call(API.deletePublisher, publisher);
    yield put({
      type: actionTypes.PUBLISHER_DELETE_SUCCESS,
      publisher,
    });
  } catch (error) {
    yield put({
      type: actionTypes.PUBLISHER_DELETE_ERROR,
      error,
    });
  }
}



// WEBPACK FOOTER //
// src/redux/sagas/publishers.js